import { Rows3, Rows4 } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import type { TableDensity } from './DataTable';

interface Props {
  value: TableDensity;
  onChange: (v: TableDensity) => void;
  className?: string;
}

/**
 * Two-button compact/comfortable toggle for table density. Pair with
 * DataTable's `density` prop. Render inside a TooltipProvider — this
 * component does not own the provider.
 */
export function DensityToggle({ value, onChange, className }: Props) {
  return (
    <div
      className={cn(
        'inline-flex h-8 items-center rounded-md border border-border bg-background p-0.5',
        className,
      )}
    >
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={() => onChange('compact')}
            className={cn(
              'grid h-7 w-7 place-items-center rounded transition-colors',
              value === 'compact'
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
            aria-label="Compact density"
          >
            <Rows4 className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent>Compact</TooltipContent>
      </Tooltip>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            type="button"
            onClick={() => onChange('comfortable')}
            className={cn(
              'grid h-7 w-7 place-items-center rounded transition-colors',
              value === 'comfortable'
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:text-foreground',
            )}
            aria-label="Comfortable density"
          >
            <Rows3 className="h-3.5 w-3.5" />
          </button>
        </TooltipTrigger>
        <TooltipContent>Comfortable</TooltipContent>
      </Tooltip>
    </div>
  );
}
